__turbopack_context__.v({
  "picture": "index-module-scss-module__cDIc3W__picture",
  "presence_online_status": "index-module-scss-module__cDIc3W__presence_online_status",
  "rounded_user_badge": "index-module-scss-module__cDIc3W__rounded_user_badge",
  "small": "index-module-scss-module__cDIc3W__small",
});
